import { useEffect } from 'react'

import {
  Box, Link, Text,
} from '@domain-group/suit-theme'

import useConversation, { UseConversationPayload } from '@hooks/useConversation'

import ConversationContainer from '@components/ConversationContainer'

import defaultRequestOptions from '@sections/Client/packs/Campaign/defaultRequestOptions'

import { ConversationModel } from '@models/types'
import Subscribers from './Subscribers'

type MarkCommentsAsReadParams = {
  conversation: ConversationModel,
  markCommentsAsReadFn: UseConversationPayload['callbacks']['markCommentsAsRead'],
}

const markCommentsAsRead = (params: MarkCommentsAsReadParams) => {
  const { markCommentsAsReadFn, conversation } = params

  if (conversation.id){
    markCommentsAsReadFn({ include_conversation_unread_count: true })
  }
}

interface ConversationProps {
  conversation: Partial<ConversationModel>,
}

const Conversation = (props: ConversationProps) => {
  const { conversation: initConversation = {} } = props

  const useConversationPayload = useConversation(
    initConversation,
    {
      performHttpRequests: !!initConversation.id,
      requestOptions: defaultRequestOptions.conversation,
    },
  )

  const {
    callbacks: { markCommentsAsRead: markCommentsAsReadFn },
    conversation,
    subjectUrl,
  } = useConversationPayload

  const {
    subject_id, subject_type, title,
  } = conversation
  const linkText = `${subject_type} #${subject_id}`

  useEffect(() => markCommentsAsRead({ conversation, markCommentsAsReadFn }), [])

  return (
    <Box flexDirection="column" variant="white">
      <Box
        alignItems="center"
        borderBottom="1px solid"
        borderColor="lineColor"
        justifyContent="space-between"
        padding="large"
      >
        <Box flexDirection="column">
          <Text fontSize="small">{title || 'Conversation' }</Text>

          {subjectUrl && (
            <Link
              href={subjectUrl}
              textProps={{ display: ['none', 'block'], fontSize: 'xsmall', marginTop: 'medium' }}
            >
              {linkText}
            </Link>
          )}

          {!subjectUrl && subject_id && subject_type && (
            <Text color="mysteryGrey" fontSize="xsmall" marginTop="medium">
              {linkText}
            </Text>
          )}
        </Box>

        <Subscribers conversation={conversation} />
      </Box>

      <ConversationContainer
        boxProps={{ padding: 'large', paddingTop: 0 }}
        commentsBoxProps={{ maxHeight: '400px' }}
        conversation={conversation}
        showCommentAttachments
        // @ts-expect-error TS2322
        performHttpRequests={false}
        requestOptions={defaultRequestOptions.conversation}
      />
    </Box>
  )
}

export default Conversation
